import { useQueryClient } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import type { JoiningDocumentsView } from '@nest-recruit/shared';
import { applicationDocumentsKey, useApplicationDocuments } from '../api/hires-api';
import { JoiningDocumentsPanel } from './JoiningDocumentsPanel';

/**
 * CAND-03's joining documents (N-59 lands here): the same panel as the hire screen, for the
 * application whose offer was accepted. Nothing shows until there is one.
 */
export function ApplicationJoiningDocuments({ applicationId }: { readonly applicationId: string | null }): ReactNode {
  const queryClient = useQueryClient();
  const query = useApplicationDocuments(applicationId);
  if (!applicationId || !query.data) return null;
  const write = (next: JoiningDocumentsView): void => {
    queryClient.setQueryData(applicationDocumentsKey(applicationId), next);
  };
  return <JoiningDocumentsPanel view={query.data} write={write} />;
}
